module.exports = __webpack_public_path__ + "media/images/icon-name-b3000b513ca5b0b65a0be26edf8513e9.svg";